import MiddlewareBase from "@/router/middleware/MiddlewareBase";
import {NavigationGuardNext, RouteLocationNormalized} from "vue-router";
import AuthController from "@/controllers/global/AuthController";
import {useAuthStore} from "@/stores/Auth";
import {UserRole} from "@/models/UserRole";
import {loadingController} from "@ionic/vue";
import WebPushService from "@/services/WebPushService";

export default class AuthMiddleware extends MiddlewareBase {
    private loadingModal?: HTMLIonLoadingElement;

    private async showLoadingModal() {
        this.loadingModal = await loadingController.create({message: "Applikation wird gestartet"});
        await this.loadingModal.present();
    }

    private async dismissLoadingModal() {
        if (this.loadingModal) await this.loadingModal.dismiss();
    }

    public async execute(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
        try {
            /*----- -----*/
            if (from.path === "/") {
                await this.showLoadingModal();
            }
            const controller = new AuthController();
            const authStore = useAuthStore();
            await authStore.init();
            /*----- verify access token -----*/
            const accessToken = await authStore.getAccessToken();
            if (accessToken === null || accessToken === "") {
                await this.dismissLoadingModal();
                next({name: "welcome"});
                return false;
            }
            /*----- store mandant and user in localstorage -----*/
            const user = await controller.getMe();
            const mandanten = await controller.getMandanten();


            await authStore.setUser(user);
            await authStore.setMandanten(mandanten);
            if (!user) {
                await this.dismissLoadingModal();
                next({name: "welcome"});
                return false;
            }
            /*----- redirect admins to admin dashboard and deny access to other pages -----*/
            if (user.identityRoles && user.identityRoles.includes(UserRole.MANDANT_ADMIN)) {
                // admin tries to access other pages - deny access
                if (!to.path.includes("admin")) {
                    await this.dismissLoadingModal();
                    next({name: "admin"});
                    return false;
                }
            }
            await this.dismissLoadingModal();
            /*----- auto-enable push notifications (user + mandant are guaranteed here) -----*/
            WebPushService.getInstance().tryAutoEnable();
            return true;
        } catch (error: any) {
            await this.dismissLoadingModal();
            console.log("AuthMiddleware error", error);
            /*----- network error - likely due to maintenance work -----*/
            if (error.code === "ERR_NETWORK") {
                next({name: "maintenance"});
                return false;
            }
            if (error.code == "ERR_CANCELED") {
                const authStore = useAuthStore();
                await authStore.clearStorage();
                next({name: "welcome"});
                return false;
            }
            if (error.response && error.response.statusText && error.response.statusText.includes("Unauthorized")) {
                console.log("user is not authenticated - redirect to welcome page");
                const authStore = useAuthStore();
                await authStore.clearStorage();
                next({name: "welcome"});
                return false;
            }
            next({name: "welcome"});
            return false;
        }
    }
}
